import { BlockType } from '../../types/index.js';
import { ImageBlock as Component } from './Block.js';
export const RegisteredImageBlock = (_intl) => ({
    recommendedName: 'Image',
    Component,
    config: { type: BlockType.BuildingBlock },
});
//# sourceMappingURL=registered.js.map